import { Component } from '@angular/core';
import { IonicPage, NavController, Platform, ToastController, LoadingController } from 'ionic-angular';
import { FormGroup, AbstractControl } from '@angular/forms';

import { HomePage } from '../home/home';

import { APIOnLine } from '../../services/api/api.services';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { iConfiguracion } from '../../models/basePage';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Proxy } from '../../services/proxy/proxy.service';
import { AdministradorPage } from '../administrador/administrador';
import { PaginaBasica } from '../../models/PaginaBase';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage extends PaginaBasica {

  // #region Propiedades del controlador
  mostrarContrasenia: boolean = false;
  username: AbstractControl;
  password: AbstractControl;
  errorMessage: string = null;
  loginForm: FormGroup;
  public configuraciones: iConfiguracion;
  public usuario: string = "";
  public contrasenia: string = "";

  public arbitro: Proxy.PrArbitro;
  // #endregion

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    private platform: Platform,
    private splashScreen: SplashScreen,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    this.Persistentes.SetArbitro(null);

    this.arbitro = new Proxy.PrArbitro(this.CFutbolActas, this.DBService2, this.Persistentes);

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
        console.log(resultado);
        return this.platform.ready();
      })
      .then(result => {
        if (!this.configuraciones.online) {
          this.splashScreen.hide();
        }
      });
  }

  // #region Métodos privados del controlador

  public login(form: NgForm) {
    if (form.valid) {
      if (!this.configuraciones.online && this.usuario.trim().toUpperCase() == "RESET" && this.contrasenia.trim().toUpperCase() == "RESET") {
        this.MostrarOcultarCarga();
        // Elimina toda la información de la base de datos y la vuelve a iniciar
        this.DBService2.destroy()
          .then(() => {
            this.MostrarOcultarCarga();
            this.navCtrl.setRoot(LoginPage);
            this.navCtrl.first();
            this.Mensaje('Se han eliminado todos los datos almacenados en la aplicación.', 3000);
          })
          .catch((error) => {
            console.error(error);
            this.Error(error, 'ERROR. No se ha podido realizar la eliminación de la base de datos.');
          });
      }
      else {
        // Validación de super usuario
        if ((this.usuario.trim().toUpperCase() == "JOSE" && this.contrasenia.trim().toUpperCase() == "SAUZAL23") ||
          (this.usuario.trim().toUpperCase() == "MIGUEL" && this.contrasenia.trim().toUpperCase() == "METROPOLE") ||
          (this.usuario.trim().toUpperCase() == "JAVIER" && this.contrasenia.trim().toUpperCase() == "PANORAMA")) {
          this.navCtrl.setRoot(AdministradorPage);
          this.navCtrl.first();
        }
        else {
          this.MostrarOcultarCarga();
          this.arbitro.Validar(this.usuario, this.contrasenia)
            .then((resultado: boolean) => {
              this.MostrarOcultarCarga();
              this.navCtrl.setRoot(HomePage);
              this.navCtrl.first();
            })
            .catch(error => {
              console.log(error);
              this.MostrarOcultarCarga(true);
              this.Error(error, "ERROR en la validación del árbitro");
            });
        }
      }
    }
  }
  // #endregion

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts